import React from 'react';
import {Box} from '@mui/material';
import {SocialAlreadyRegisteredScreenType} from '@practicegenius/register-account/src/screens/SocialAlreadyRegistered';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {AlreadyRegisteredContent} from '../components/AlreadyRegisteredContent';
import {SocialLoginButtons} from '../../../components/SitesDotSocialLoginButtons';

export const SocialAlreadyRegistered: SocialAlreadyRegisteredScreenType = ({
  lang,
  providers,
  onPrimaryActionClick,
  links,
  ...otherProps
}) => (
  <BaseScreen
    helmetTitle={lang.pageTitle}
    headerTitle={lang.headerTitle}
    title={lang.title}
    actionButtons={
      !links.forgot_password
        ? undefined
        : [
            {
              children: lang.buttons.primary.title,
              onClick: onPrimaryActionClick,
              id: 'login_button',
              customWidth: 'extraWide',
              customHeight: 'tall',
              color: 'primary',
            },
          ]
    }
    afterButtons={
      <Box mt={links.forgot_password ? 2.5 : undefined}>
        <SocialLoginButtons
          platforms={providers}
          // The only error we expect here is an incomplete registration
          onLoginError={err => {
            window.location.href = `/login?token=${
              // @ts-ignore
              err.response.data.token ?? ''
            }&error=registration_not_finished&viaSocial=1`;
          }}
        />
      </Box>
    }
  >
    <AlreadyRegisteredContent lang={lang} links={links} {...otherProps} />
  </BaseScreen>
);
